(function () {
  if (window.__AG_PB_PARALLAX_COLUMNS_INIT__) return;
  window.__AG_PB_PARALLAX_COLUMNS_INIT__ = true;

  var PX_PER_SECOND = 36;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getItems(track) {
    return Array.prototype.slice.call(track.querySelectorAll('[data-ag-px-item]'));
  }

  function clearClones(track) {
    Array.prototype.slice.call(track.children).forEach(function (child) {
      if (!child.hasAttribute('data-ag-px-item')) {
        child.remove();
      }
    });
  }

  function measureSetHeight(track, items) {
    if (!items.length) return 0;
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.rowGap || styles.gap) || 0;
    var height = 0;

    items.forEach(function (item, index) {
      height += item.getBoundingClientRect().height;
      if (index < items.length - 1) height += gap;
    });

    /* Include gap between last original item and first clone */
    height += gap;
    return height;
  }

  function buildColumn(col) {
    var track = col.querySelector('.js-ag-pb-px-track');
    if (!track) return;

    clearClones(track);

    var items = getItems(track);
    if (!items.length) return;

    if (prefersReducedMotion()) {
      col.style.setProperty('--ag-pb-px-loop', '0px');
      return;
    }

    var setHeight = measureSetHeight(track, items);
    if (setHeight <= 0) return;

    items.forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.removeAttribute('data-ag-px-item');
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });

    col.style.setProperty('--ag-pb-px-loop', Math.round(setHeight) + 'px');

    var duration = Math.max(12, setHeight / PX_PER_SECOND);
    var prop = col.getAttribute('data-direction') === 'down'
      ? '--ag-pb-px-duration-down'
      : '--ag-pb-px-duration-up';
    col.style.setProperty(prop, duration.toFixed(2) + 's');
  }

  function rebuildBlock(root) {
    var cols = root.querySelectorAll('.js-ag-pb-px-col');
    Array.prototype.forEach.call(cols, buildColumn);
  }

  /* The two strips are ~2.4 MB and sit far below the fold, so their src is held back
     until the block is near the viewport. Clones copy whatever src the original has. */
  var IMG_SRC_ATTR = 'data-ag-px-src';

  function loadImages(root, onLoad) {
    Array.prototype.forEach.call(root.querySelectorAll('img[' + IMG_SRC_ATTR + ']'), function (img) {
      var src = img.getAttribute(IMG_SRC_ATTR);
      img.removeAttribute(IMG_SRC_ATTR);
      img.addEventListener('load', onLoad, { once: true });
      img.src = src;
    });
  }

  function initBlock(root) {
    if (root.dataset.agPbPxBound) return;
    root.dataset.agPbPxBound = '1';

    function rebuild() {
      rebuildBlock(root);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(rebuild).catch(rebuild);
    } else {
      rebuild();
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(rebuild, 150);
    });

    Array.prototype.forEach.call(root.querySelectorAll('img'), function (img) {
      if (img.complete) return;
      img.addEventListener('load', rebuild, { once: true });
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        io.disconnect();
        loadImages(root, rebuild);
      }, { rootMargin: '1200px 0px' });
      io.observe(root);
    } else {
      loadImages(root, rebuild);
    }
  }

  function initAll() {
    document.querySelectorAll('.js-ag-pb-parallax-columns').forEach(initBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.js-ag-pb-parallax-columns').forEach(function (root) {
      delete root.dataset.agPbPxBound;
      initBlock(root);
    });
  });
})();
